import { TenantStatusEnum } from '../enums/tenant-status.enum';
import { TENANT_ACCESS_BLOCKING_STATUSES } from '../consts/tenant-access-blocking-statuses.const';

/**
 * Single source of truth for the access gate rule.
 * Blocked iff status is in TENANT_ACCESS_BLOCKING_STATUSES
 * (unpaid / paused / canceled). PAST_DUE is grace (not blocked).
 *
 * SQL mirror: platform.fn_tenant_access_blocked.
 */
export function isTenantAccessBlocked(status: TenantStatusEnum): boolean {
  return TENANT_ACCESS_BLOCKING_STATUSES.has(status);
}
